
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gCCS5mS6_450phJxhmdthxFQ6BJ15lVO7FRqwG33Wmegy0Meta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexbT7cHdmriCPfBEp868k_45fU0n7m2SrNZlYlvzhf2T7E8Meta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search11WgKKLI4zqemP7rK3ieNdu8DPMsO6aCfw4J25vg6xAMeta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexqkXzR2me3MV9wSJfn3YYbZEAkDMFWVTiU4nTNAAnuKcMeta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Iyzr1jMAl62ns5WalO8ARRla98nKwOqtjL4HfVlPWEoMeta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index74bzRXIZdutirKsTVHuRca_45uf7IU_45KkL8y7tOF5YilkMeta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93CiJ9Uvik9qilPqYKSxmpxca9msmqvWlJ6grrBwKOV9YMeta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index4kMvsUm3ASnfbqwTMYN_45VR6Z_faRudrOH8jPGmjH3_4Meta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93dXYqweRiWFq0DtPLwummTj7Y_Ii7NNC9Ptl_4Z0EZQIMeta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexIHtLOodoHH1B8pN0gn6KUlm6eLMwQz2LCOySYLmQS90Meta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index5wzGL0vtYd_45ovsuyzhD4UplMXRisRDje0pw9Q_E7lj4Meta } from "/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index74bzRXIZdutirKsTVHuRca_45uf7IU_45KkL8y7tOF5YilkMeta || {},
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index4kMvsUm3ASnfbqwTMYN_45VR6Z_faRudrOH8jPGmjH3_4Meta || {},
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexIHtLOodoHH1B8pN0gn6KUlm6eLMwQz2LCOySYLmQS90Meta || {},
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index5wzGL0vtYd_45ovsuyzhD4UplMXRisRDje0pw9Q_E7lj4Meta || {},
    component: () => import("/codebuild/output/src965955603/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]